const INITIAL_STATE = {
  data: {}, 
  tickets: {},
  report:{}, 
  errors: {}
}
                
const invoiceReconciliationReport = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_INVOICE_RECONCILIATION_REPORT_SUCCESSFULLY':
    return { ...state, ...INITIAL_STATE, report: action.data }
  case 'GET_INVOICE_RECONCILIATION_REPORT_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
          
export default invoiceReconciliationReport;